'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002422 from "./presto.-Agent-View$$anon$22.js";
import * as $j_presto$002etypes$0024$002dBase64$002dString$0024 from "./presto.types$-Base64-String$.js";
import * as $j_presto$002etypes$0024proto$0024$002dFile$002dContent$0024 from "./presto.types$proto$-File-Content$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$21() {
  this.ay6 = null;
  this.axY = null;
  this.axZ = false;
  this.ay7 = null;
  this.ay8 = false;
  this.ayb = null;
  this.ay4 = null;
  this.ay5 = false;
  this.ay0 = null;
  this.ay1 = false;
  this.ay2 = null;
  this.ay3 = false;
  this.ay9 = false;
  this.aya = false;
  this.ay6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.ayb = "FileContent";
}
export { $c_Lpresto_AgentView$$anon$21 as $c_Lpresto_AgentView$$anon$21 };
$p = $c_Lpresto_AgentView$$anon$21.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$21;
/** @constructor */
function $h_Lpresto_AgentView$$anon$21() {
}
export { $h_Lpresto_AgentView$$anon$21 as $h_Lpresto_AgentView$$anon$21 };
$h_Lpresto_AgentView$$anon$21.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.ay6;
});
$p.M = (function() {
  if ((!this.axZ)) {
    this.axY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.axZ = true;
  }
  return this.axY;
});
$p.O = (function() {
  if ((!this.ay8)) {
    this.ay7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.ay8 = true;
  }
  return this.ay7;
});
$p.D = (function() {
  return this.ayb;
});
$p.t = (function() {
  if ((!this.ay5)) {
    this.ay4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("content", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.ay5 = true;
  }
  return this.ay4;
});
$p.N = (function() {
  if ((!this.ay1)) {
    this.ay0 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dBase64$002dString$0024.$m_Lpresto_types$Base64String$().ra(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.ay1 = true;
  }
  return this.ay0;
});
$p.Q = (function() {
  if ((!this.ay3)) {
    this.ay2 = new $j_presto$002e$002dAgent$002dView$0024$0024anon$002422.$c_Lpresto_AgentView$$anon$22();
    this.ay3 = true;
  }
  return this.ay2;
});
$p.v = (function() {
  if ((!this.aya)) {
    this.ay9 = false;
    this.aya = true;
  }
  return this.ay9;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee149) => ((p) => \u03b4scrutinee149.cHN(p)))($j_presto$002etypes$0024proto$0024$002dFile$002dContent$0024.$m_Lpresto_types$proto$FileContent$())));
});
var $d_Lpresto_AgentView$$anon$21 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$21, "presto.AgentView$$anon$21", ({
  DQ: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$21 as $d_Lpresto_AgentView$$anon$21 };
//# sourceMappingURL=presto.-Agent-View$$anon$21.js.map
